<!-- Modal de Lista de Espera -->
<div *ngIf="showWaitlistModal" class="waitlist-modal-overlay" (click)="closeWaitlistModal()">
    <div class="waitlist-modal" (click)="$event.stopPropagation()">
        <div class="waitlist-modal-content">
            <!-- Header Text -->
            <div class="modal-header-text">
                <p>Descubre todo lo que Phoenix Professional tiene para ti</p>
            </div>

            <!-- Sección de Video -->
            <div class="video-section">
                <div class="video-container">
                    <!-- Usar nuestro componente reutilizable YouTube Player -->
                    <div #youtubePlayer>
                        <app-youtube-player
                            *ngIf="getProfessionalVideoId()"
                            [videoId]="getProfessionalVideoId()!"
                            [params]="getVideoParams()"
                        ></app-youtube-player>
                    </div>
                    
                    <!-- Mensaje de error si no hay video ID -->
                    <div *ngIf="!getProfessionalVideoId()" class="error-message">
                        <p>No se pudo cargar el video profesional</p>
                    </div>
                </div>
            </div>

            <!-- Header Text -->
            <div class="modal-header-text">
                <h2>Únete a nuestra lista de espera para convertirte en Phoenix Professional</h2>
                <p>Sé el primero en acceder a todas las increíbles actividades que tenemos para ti</p>
            </div>

            <!-- Formulario -->
            <form class="waitlist-form" (ngSubmit)="submitWaitlistForm()">
                <div class="form-row">
                    <div class="form-group">
                        <label>Nombre <span class="required">*</span></label>
                        <input 
                            type="text" 
                            [(ngModel)]="waitlistForm.nombre"
                            name="nombre"
                            placeholder="Ingrese nombre"
                            required>
                    </div>
                    
                    <div class="form-group">
                        <label>Apellido <span class="required">*</span></label>
                        <input 
                            type="text" 
                            [(ngModel)]="waitlistForm.apellido"
                            name="apellido"
                            placeholder="Ingrese apellido"
                            required>
                    </div>

                    <div class="form-group">
                        <label>Teléfono <span class="required">*</span></label>
                        <input 
                            type="tel" 
                            [(ngModel)]="waitlistForm.telefono"
                            name="telefono"
                            placeholder="Ingrese teléfono"
                            required>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label>Correo electrónico <span class="required">*</span></label>
                        <input 
                            type="email" 
                            [(ngModel)]="waitlistForm.correoElectronico"
                            name="correoElectronico"
                            placeholder="Ingrese correo"
                            required>
                    </div>
                    
                    <div class="form-group">
                        <label>Provincia <span class="required">*</span></label>
                        <select 
                            [(ngModel)]="waitlistForm.provincia"
                            name="provincia"
                            (change)="onProvinciaChange()"
                            required>
                            <option value="">Ingrese provincia</option>
                            <option *ngFor="let provincia of provincias" [value]="provincia">
                                {{ provincia }}
                            </option>
                        </select>
                    </div>
                    
                    <div class="form-group">
                        <label>Distrito <span class="required">*</span></label>
                        <select 
                            [(ngModel)]="waitlistForm.distrito"
                            name="distrito"
                            [disabled]="!waitlistForm.provincia"
                            required>
                            <option value="">Ingrese distrito</option>
                            <option *ngFor="let distrito of getDistritosByProvincia()" [value]="distrito">
                                {{ distrito }}
                            </option>
                        </select>
                    </div>
                </div>

                <button 
                    type="submit" 
                    class="register-button"
                    [disabled]="!isWaitlistFormValid() || isSubmittingWaitlist">
                    <span *ngIf="!isSubmittingWaitlist">Registrarme</span>
                    <span *ngIf="isSubmittingWaitlist">Registrando...</span>
                </button>
            </form>

            <!-- Sección de Beneficios -->
            <div class="benefits-section">
                <h3>Beneficios de registrarte</h3>
                <div class="benefits-list">
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Primer beneficio</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Segundo beneficio</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Tercer beneficio</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Cuarto beneficio</span>
                    </div>
                </div>
            </div>

            <!-- Botón de cerrar -->
            <button class="close-button" (click)="closeWaitlistModal()">
                <span>×</span>
            </button>
        </div>
    </div>
</div>

<div class="plans-container">
    <!-- Encabezado con título y breadcrumb -->
    <!-- <div class="plans-header">
        <h1 class="page-title">Programas</h1>
        <div class="breadcrumb">home/ programas</div>
    </div> -->
    
    <!-- Separador -->
    <!-- <div class="separator-line"></div> -->
    
    <!-- Subtítulo y descripción -->
    <div class="plans-subheader">
        <div class="title-section">
            <h2 class="subtitle">Suscripción</h2>
            <p class="subtitle-description">Aquí puedes ver tu programa actual y descubrir las opciones para avanzar, construir y sostener tu plan de vida con acompañamiento real.</p>
        </div>
        
        <!-- Botones de toggle para anual/trimestral -->
        <!-- <div class="period-toggle">
            <div class="toggle-button-wrapper">
                <button class="toggle-btn" [class.active]="selectedPeriod === 'anual'" (click)="togglePeriod('anual')">
                    Anual -15%
                </button>
                <button class="toggle-btn" [class.active]="selectedPeriod === 'trimestral'" (click)="togglePeriod('trimestral')">
                    Trimestral
                </button>
            </div>
        </div> -->
    </div>
    
    <!-- Contenido de planes -->
    <div class="plans-view-container">
        <div *ngIf="loading" class="loading-container">
            <p>Cargando programas disponibles...</p>
        </div>
        
        <div *ngIf="error" class="error-container">
            <p class="error-message">{{ error }}</p>
            <button class="retry-button" (click)="loadSubscriptionTypes()">Reintentar</button>
        </div>
        
        <!-- Planes directamente en la vista -->
        <div *ngIf="!loading && !error" class="plans-content">
                         <!-- Tarjetas de planes -->
             <div class="plan-options">
                 <!-- PLAN FREEMIUM -->
                 <div class="plan-card freemium-card">
                     <div class="plan-content">
                         <div class="plan-header">
                             <h2>Freemium</h2>
                             <p class="plan-subtitle">Sin costo</p>
                             <p class="plan-description">Descubre el estado actual de aspectos esenciales de tu vida y potencia tu etapa phoenix.</p>
                         </div>
                         
                         <div class="plan-features">
                             <p class="features-title">Beneficios:</p>
                             <ul class="features-list">
                                 <li><span class="checkmark">✓</span>Diagnóstico de vida, identifica tus fortalezas y áreas de mejora.</li>
                                 <li><span class="checkmark">✓</span>Creación de objetivos iniciales para empezar tu recorrido.</li>
                                 <li><span class="checkmark">✓</span>Acceso al directorio de expertos</li>
                                 <li><span class="checkmark">✓</span>Lecturas y recursos ilimitados en Academy para inspirarte y aprender.</li>
                             </ul>
                         </div>
                         
                         <div class="plan-action">
                             <button class="plan-button freemium-button" (click)="subscribeToPlan('freemium')">Tu plan actual</button>
                         </div>
                     </div>
                 </div>
                 
                 <!-- PLAN PROFESSIONAL -->
                 <div class="plan-card professional-card">
                     <div class="plan-content">
                         <div class="plan-header">
                             <h2>Professional</h2>
                             <p class="plan-subtitle">Próximamente</p>
                             <p class="plan-description">Diseña tu plan de vida con próposito rodeado de profesionales que comparten tus metas y tu visión de crecimiento.</p>
                         </div>
                         
                         <div class="plan-features">
                             <p class="features-title">Todo lo de Phoenix Freemium más:</p>
                             <ul class="features-list">
                                 <li><span class="checkmark">✓</span>Sesión grupal mensual para avanzar en comunidad.</li>
                                 <li><span class="checkmark">✓</span>Mentor digital 24/7 disponible para guiarte en cualquier momento.</li>
                                 <li><span class="checkmark">✓</span>Crea tu plan de vida y define objetivos claros con seguimiento.</li>
                                 <li><span class="checkmark">✓</span>Acceso completo al directorio de expertos.</li>
                                 <li><span class="checkmark">✓</span>Acceso a la Academy con contenidos avanzados.</li>
                                 <li><span class="checkmark">✓</span>Acceso a Phoenix Sessions.</li>
                                 <li><span class="checkmark">✓</span>Rutas de reinvención y herramientas personalizadas para tu progreso.</li>
                             </ul>
                         </div>
                         
                         <div class="plan-action">
                             <button class="plan-button professional-button" (click)="subscribeToPlan('professional')">Unirme a la lista de espera</button>
                         </div>
                     </div>
                 </div>
                 
                 <!-- PLAN EXECUTIVE -->
                 <div class="plan-card executive-card">
                     <div class="plan-content">
                         <div class="plan-header">
                             <h2>Executive</h2>
                             <p class="plan-subtitle">Aplica ahora</p>
                             <p class="plan-description">Sé parte de Phoenix Executive, el programa diseñado para guiarte en la construcción de tu plan de vida, reconectar con tu propósito y compartir experiencias con una comunidad que impulsa el bienestar.</p>
                         </div>
                         
                         <div class="plan-features">
                             <p class="features-title">Todo lo de Phoenix Professional más:</p>
                             <ul class="features-list">
                                 <li><span class="checkmark">✓</span>Programa de 3 meses centrado en tu plan de vida.</li>
                                 <li><span class="checkmark">✓</span>6 horas de mentoría personalizada distribuidas a lo largo del programa.</li>
                                 <li><span class="checkmark">✓</span>4 horas de sesiones con expertos especializados.</li>
                                 <li><span class="checkmark">✓</span>Phoenix Session mensual.</li>
                                 <li><span class="checkmark">✓</span>Herramientas de seguimiento vinculadas a tu plan de vida.</li>
                                 <li><span class="checkmark">✓</span>Marketplace de expertos para ampliar tu acompañamiento si lo deseas.</li>
                                 <li><span class="checkmark">✓</span>Acceso completo a la Academy y recursos exclusivos.</li>
                             </ul>
                         </div>
                         
                         <div class="plan-action">
                             <button class="plan-button executive-button" (click)="subscribeToPlan('executive')">Me interesa</button>
                         </div>
                     </div>
                 </div>
             </div>

            <!-- Tabla de comparación -->
            <!-- <div class="comparison">
                <p class="comparison-text">Comparar programas</p>
                <div class="comparison-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Descripción</th>
                                <th>Freemium</th>
                                <th>Professional</th>
                                <th>Executive</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let feature of featuresList" [ngClass]="{'ondemand-row': feature.isOnDemand}">
                                <td>
                                    {{ feature.description }}
                                    <span class="info-icon" title="Más información"></span>
                                </td>
                                <td><span [class]="feature.freemium"></span></td>
                                <td><span [class]="feature.professional"></span></td>
                                <td><span [class]="feature.executive"></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
        </div>
    </div>
</div>